<ng-container>
  <div class="modal-header">
    <h3
      style="font-size: 26px; text-align: center"
      class="modal-title"
      [innerHTML]="options.headerText"></h3>
  </div>

  <div class="modal-body __s">
    <span
      style="font-size: 18px"
      [innerHTML]="options.bodyText"></span>
  </div>
</ng-container>
